import PhoneNumberInput from "components/base/PhoneNumberInput/PhoneNumberInput";

export default PhoneNumberInput;
